var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPromoCode = function SvgPromoCode(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47193 0.762813C6.98762 0.700721 6.50186 0.86653 6.1566 1.21179L0.711781 6.65661C0.0960731 7.27232 0.0960731 8.27058 0.711781 8.88629L4.61371 12.7882C5.22942 13.4039 6.22768 13.4039 6.84339 12.7882L12.2882 7.3434C12.6335 6.99814 12.7993 6.51238 12.7372 6.02807L12.2938 2.56954C12.2025 1.85781 11.6422 1.29746 10.9305 1.20621L7.47193 0.762813ZM8.23711 5.2662C8.69889 5.72798 9.44759 5.72798 9.90937 5.2662C10.3712 4.80442 10.3712 4.05572 9.90937 3.59394C9.44759 3.13216 8.69889 3.13216 8.23711 3.59394C7.77533 4.05572 7.77533 4.80442 8.23711 5.2662Z",
    fill: "#A6A6A6"
  })));
};
export default SvgPromoCode;